
export enum GeoLocationTypeCd {
	CUSTOMER_LOCATION = 'CustomerLocation',
	DROP_LOCATION = 'DropLocation',
	SERVICE_CENTER = 'ServiceCenter'}
